// This file was automatically generated from appchart.dialog.visitNoteEdit.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.visitNoteEdit');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.render.chartFeedItem.visitNoteContent');
goog.require('el8.template.render.chartFeedItem.visitNoteTemplate.oneCol');
goog.require('el8.template.render.chartFeedItem.visitNoteTemplate.twoCol');
goog.require('el8.template.render.signOff');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.visitNoteEdit.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="fieldSection"><div class="systemNoteContainer"><p>Changes between Original Visit Note signed on ', (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.signDate)) : ''), ' and Amended Visit Note signed on ', (soy.$$escapeHtml(opt_data.editSignDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.editSignDate)) : ''), '</p></div><div class="overlayContainer"><div class="visitNoteItem', (opt_data.isEdit) ? ' amendedNote' : '', '"><div class="headerContainer"><div class="description"><span class="statusText elt"></span>', (opt_data.newDocumentDate) ? '<span class="eltlr5 strike">' + (soy.$$escapeHtml(opt_data.replacedDocumentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.replacedDocumentDate)) : '') + '</span><span class="eltlr5 edit">' + (soy.$$escapeHtml(opt_data.newDocumentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.newDocumentDate)) : '') + '</span>' : '<span class="eltlr5">' + (soy.$$escapeHtml(opt_data.documentDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentDate)) : '') + '</span>', (opt_data.newDescription) ? '<span class="item-description-text emphasis eltlr5">-<span class="strike">' + soy.$$escapeHtml(opt_data.replacedDescription) + '</span><span class="leftIndent edit">' + soy.$$escapeHtml(opt_data.newDescription) + '</span>-</span>' : '<span class="item-description-text emphasis eltlr5">- ' + soy.$$escapeHtml(opt_data.description) + ' -</span>', '</div></div><div class="noteFormContent"><div class="cardDetails">');
  el8.template.render.chartFeedItem.visitNoteContent.sectionReason({reason: opt_data.reason, age: opt_data.age}, output);
  if (opt_data.templateClass == 'oneCol') {
    el8.template.render.chartFeedItem.visitNoteTemplate.oneCol.content(opt_data, output);
  } else {
    el8.template.render.chartFeedItem.visitNoteTemplate.twoCol.content(opt_data, output);
  }
  output.append('<div class="cardColumnBg">');
  if (opt_data.signDate) {
    el8.template.render.signOff.summary(opt_data, output);
  }
  if (opt_data.edits) {
    var eList3106 = opt_data.edits;
    var eListLen3106 = eList3106.length;
    for (var eIndex3106 = 0; eIndex3106 < eListLen3106; eIndex3106++) {
      var eData3106 = eList3106[eIndex3106];
      output.append('<p class="el8SignoffText">Amended and signed by ', soy.$$escapeHtml(eData3106.signUserName), ' on ', (soy.$$escapeHtml(eData3106.signDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(eData3106.signDate)) : ''), ' ', (! opt_data.isEdit) ? '<a class="edit-changes-trigger" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '" _id="' + soy.$$escapeHtml(eData3106.id) + '">(see changes)</a>' : '', '</p>');
    }
  }
  output.append('</div></div></div></div></div></div>');
  if (!opt_sb) return output.toString();
};
